import React, { useEffect, useRef, useState } from "react";
import ProgressBar from "react-customizable-progressbar";
import runninggirl from "../../assets/images/gym/running.png";
import BaseImage from "../../assets/images/dasboard/base.webp";
import fastinginprogressbg from "../../assets/images/dasboard/fastinginprogressbg.png";
import fastinginprogressbg1 from "../../assets/images/dasboard/fastinginprogressbg1.png";
import stopBase from "../../assets/images/dasboard/StopBase.png";
import alarm from "../../assets/images/dasboard/alarm.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import MainBg from "../../components/Mainbg";
import secureLocalStorage from "react-secure-storage";
import axios from "axios";
import { POST_WORKOUT_LOG_ENDPOINT } from "../../config/ApisCollection";

const GymCenterView = () => {
  const location = useLocation();
  let history = useNavigate();
  const workoutChoosedData = location.state;
  const accessToken = secureLocalStorage.getItem("accessToken");
  const videoRef = useRef();
  const videoId = location.state.id;

  const [playStatus, setPlayStatus] = useState("start");
  const [currentTime, setCurrentTime] = useState({
    minutes: 0,
    seconds: 0,
  });
  const [playedPercentage, setPlayedPercentage] = useState(0);

  const [progress, setProgress] = useState({
    start: 0,
    playing: 0,
    stoped: 100,
  });

  const playVideo = () => {
    videoRef.current.play();
    setPlayStatus("playing");
  };

  const pauseVideo = () => {
    videoRef.current.pause();
    setPlayStatus("paused");
  };

  const stopVideo = () => {
    videoRef.current.pause();
    videoRef.current.currentTime = 0;
    setPlayStatus("stoped");
    setCurrentTime(0);
    PostWorkoutLog();
  };

  const updateCurrentTime = () => {
    if (videoRef.current) {
      const totalSeconds = Math.floor(videoRef.current.currentTime);
      const min = Math.floor(totalSeconds / 60);
      const sec = totalSeconds % 60;

      // setProgress({ ...progress, playing: sec });
      setCurrentTime({
        minutes: min,
        seconds: sec,
      });
    }
  };
  const handleTimeUpdate = () => {
    if (videoRef.current) {
      const currentTime = videoRef.current.currentTime;
      const duration = videoRef.current.duration;
      const percentage = (currentTime / duration) * 100;
      // setPlayedPercentage(percentage);
      setProgress({
        ...progress,
        playing: percentage,
      });
      // console.log(duration/60);
      if (percentage === 100) {
        setPlayStatus("stoped");
        PostWorkoutLog();
      }
    }
  };

  const PostWorkoutLog = async () => {
    const api_url = POST_WORKOUT_LOG_ENDPOINT + "/" + videoId;
    const postBody = {
      playTime: currentTime.minutes * 60 + currentTime.seconds,
    };
    const postHeader = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
      },
    };
    try {
      const respones = await axios.post(api_url, postBody, postHeader);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    // PostWorkoutLog();
    videoRef.current?.load();

    const intervalId = setInterval(updateCurrentTime, 1000);

    // Clear the interval when the component unmounts
    return () => clearInterval(intervalId);
  }, [workoutChoosedData?.SourceUrl]);

  if (workoutChoosedData !== null) {
    return (
      <MainBg>
        <div className="lg:w-2/6 w-full m-auto py-1">
          <div className="m-[-20px]">
            <div className="relative">
              <video
                {...playStatus}
                ref={videoRef}
                onTimeUpdate={handleTimeUpdate}
              >
                <source src={workoutChoosedData.SourceUrl}></source>
              </video>
            </div>
            <br />
            <div className="">
              {playStatus === "start" ? (
                <>
                  <GymViewProgressSection
                    progress={progress.start}
                    playVideo={playVideo}
                    playButton={"play"}
                    BaseImagePath={BaseImage}
                    PostWorkoutLog={null}
                    setPlayStatus={null}
                    setPlayStatusVal={"stoped"}
                    strokeColor="#FF9950"
                    playBtnClass="palyerdes"
                    layerBgClass="circleplayer3"
                  />
                </>
              ) : playStatus === "playing" ? (
                <>
                  {/* <GymViewProgressSection
                    progress={progress.playing}
                    playVideo={pauseVideo}
                    playButton={"pause"}
                    BaseImagePath={fastinginprogressbg1}
                    PostWorkoutLog={PostWorkoutLog}
                    setPlayStatus={setPlayStatus}
                    setPlayStatusVal={"stoped"}
                    strokeColor="#28F1C1"
                    playBtnClass="palyerdes pauseInProgress"
                    layerBgClass="circleplayer3  circleLayerPause3"
                  /> */}

                  <div className="circleplayer pt-0">
                    <div
                      className="circleplayer1 circleLayerPause1 cursor-pointer h-[120px] w-[120px]"
                      onClick={() => {
                        setPlayStatus("stoped");
                        pauseVideo();
                        PostWorkoutLog();
                      }}
                    >
                      <ProgressBar
                        strokeWidth={18}
                        strokeColor="#28F1C1"
                        strokeLinecap="round"
                        trackStrokeWidth={8}
                        className="circleplayer2 z-20 h-[125px] !w-[125px]"
                        // cut={180}
                        // rotate={-180}
                        radius={100}
                        progress={progress.playing}
                      ></ProgressBar>
                      <div className="circleplayer3  circleLayerPause3 cursor-pointer z-10 h-[110px] w-[110px]">
                        <Link to="/fastingdesh">
                          <div className="palyerdes pauseInProgress h-[50px] w-[50px]">
                            <i
                              className={`text-white fa fa-${
                                playStatus === "stoped" ? "play" : "pause"
                              }`}
                              aria-hidden="true"
                            ></i>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </div>

                  <div
                    className="desbase mb-2"
                    style={{
                      backgroundImage: "url(" + fastinginprogressbg1 + ")",
                      marginTop: "-210px",
                      height: "193px",
                    }}
                  >
                    <img
                      loading="lazy"
                      src={fastinginprogressbg}
                      alt="no-food"
                      className="deshimg opacity-25"
                    />
                  </div>
                </>
              ) : (
                <>
                  <div className="circleplayer pt-0">
                    <div
                      className="circleplayer1 cursor-pointer h-[120px] w-[120px]"
                      onClick={() => {
                        playVideo();
                      }}
                    >
                      <ProgressBar
                        strokeWidth={18}
                        strokeColor="#FF5050"
                        strokeLinecap="round"
                        trackStrokeWidth={8}
                        className="circleplayer2 z-20 h-[125px] !w-[125px]"
                        radius={100}
                        progress={progress.playing}
                        // cut={180}
                        // rotate={-180}
                      ></ProgressBar>
                      <div className="circleplayer3 circleLayerPause5 cursor-pointer z-10 h-[110px] w-[110px]">
                        <Link to="/fastingdesh">
                          <div className="palyerdes stopedProgress h-[50px] w-[50px]">
                            <i
                              className="fa fa-play text-white"
                              aria-hidden="true"
                            ></i>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div
                    className="desbase mb-2"
                    style={{
                      backgroundImage: "url(" + stopBase + ")",
                      marginTop: "-210px",
                      height: "193px",
                    }}
                  >
                    <img
                      loading="lazy"
                      src={stopBase}
                      alt="no-food"
                      className="deshimg opacity-25"
                    />
                  </div>
                </>
              )}

              <div className="grid place-items-center mt-5">
                <div className="border border-[#d3d3d3]	 px-5 py-2 leading-5 rounded font-medium text-black">
                  <div className="flex gap-2 place-items-center ">
                    <img src={alarm} /> {workoutChoosedData.duration} minutes
                  </div>
                </div>
                <h1 className="mt-3 font-bold text-lg text-capitalize">
                  {workoutChoosedData.name}
                </h1>
                {/* <div
                      dangerouslySetInnerHTML={{
                        __html: workoutChoosedData.description,
                      }}
                      className="text-[#d3d3d3]"
                    ></div> */}
                <div className="flex gap-5 mt-3">
                  <div>
                    <b className="text-5xl"> {currentTime.minutes}</b>
                    <small>m</small>
                  </div>
                  <div className="text-5xl">:</div>
                  <div>
                    <b className="text-5xl"> {currentTime.seconds}</b>
                    <small>s</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </MainBg>
    );
  }
};

const GymViewProgressSection = ({
  progress,
  playVideo,
  playButton,
  BaseImagePath,
  PostWorkoutLog,
  setPlayStatus,
  setPlayStatusVal,
  strokeColor,
  playBtnClass,
  layerBgClass,
}) => {
  return (
    <>
      <div className="circleplayer pt-0">
        <div
          className="circleplayer1 cursor-pointer h-[120px] w-[120px]"
          onClick={() => {
            playVideo();
            PostWorkoutLog();
            setPlayStatus(setPlayStatusVal);
          }}
        >
          <ProgressBar
            strokeWidth={18}
            strokeColor={strokeColor}
            strokeLinecap="round"
            trackStrokeWidth={8}
            className="circleplayer2 z-20 h-[125px] !w-[125px]"
            radius={100}
            progress={progress}
            // cut={180}
            // rotate={-180}
          ></ProgressBar>
          <div
            className={`circleplayer3 cursor-pointer z-10 h-[110px] w-[110px] ${layerBgClass}`}
          >
            <Link to="/fastingdesh">
              <div className={` h-[50px] w-[50px] ${playBtnClass}`}>
                <i
                  className={`fa fa-${playButton} text-white`}
                  aria-hidden="true"
                ></i>
              </div>
            </Link>
          </div>
        </div>
      </div>
      <div
        className="desbase mb-3"
        style={{
          backgroundImage: "url(" + BaseImagePath + ")",
          marginTop: "-210px",
          height: "193px",
        }}
      >
        <img
          loading="lazy"
          src={BaseImagePath}
          alt="no-food"
          className="deshimg opacity-25"
        />
      </div>
    </>
  );
};

export default React.memo(GymCenterView);
